module.exports = __webpack_public_path__ + "static/vol5_02-16cabe207708f989987a8da8ff79975b.gif";